import React, {useState} from "react";
import {numSeperator} from "utils/DataBase";

const TrafficPlanSelector = ({items, onPlanSelect}) => {
    const [selectedPlan, setSelectedPlan] = useState(items[0]?.value || "");

    const handlePlanChange = (plan) => {
        setSelectedPlan(plan);
        onPlanSelect(plan); // Notify parent about the selected plan
    };

    return (
        <div className="nav flex-column" role="tablist">
            {items.map((item) => (
                <label
                    key={item.id}
                    className={`nav-link btn btn-outline btn-outline-dashed btn-color-dark btn-active 
                    btn-active-primary d-flex flex-stack text-start p-6 mb-6 ${
                        selectedPlan === item.id ? "active" : ""
                    }`}
                    data-bs-toggle="tab"
                    data-bs-target={`#plan_${item.id}`}
                    aria-selected={selectedPlan === item.id}
                    role="tab"
                >
                    <div className="d-flex align-items-center me-2">
                        <div
                            className="form-check form-check-custom form-check-solid form-check-success flex-shrink-0 me-6">
                            <input
                                className="form-check-input"
                                type="radio"
                                name="plan"
                                value={item.id}
                                checked={selectedPlan === item.id}
                                onChange={() => handlePlanChange(item.id)}
                            />
                        </div>
                        <div className="flex-grow-1">
                            <div className="d-flex align-items-center fs-3 fw-bold flex-wrap">
                                {item.title}
                            </div>
                        </div>
                    </div>
                    <div className="ms-5">
                        <span
                            className="fs-2x fw-bold"
                        >
              {numSeperator(item.price)}
            </span>
                        <span className="fs-7 opacity-50 ms-1">
                            <span data-kt-element="period">ریال</span>
                        </span>
                    </div>
                </label>
            ))}
        </div>
    );
};

export default TrafficPlanSelector;
